const hiddenClass = 'selling_plan_theme_integration--hidden';

class SellingPlansWidget {
  constructor(sellingPlansWidgetContainer) {
    this.sellingPlansWidgetContainer = sellingPlansWidgetContainer;
    this.initializeElements();
    this.attachEventListeners();
    this.setDefaultPurchaseOption();
    this.updateOptionsVisualState();
    this.updatePrice();
  }

  initializeElements() {
    this.sectionId = this.sellingPlansWidgetContainer.getAttribute('data-section-id');
    this.shopifySection = document.querySelector(`#shopify-section-${this.sectionId}`);
    this.sellingPlanForm = this.shopifySection?.querySelector('.selling_plan_theme_integration') || document.querySelector('.selling_plan_theme_integration');
    this.buyButtonInput = document.querySelector('.product-buy-buttons--input');
    this.sellingPlanInput = this.shopifySection?.querySelector('.selected-selling-plan-id') || document.querySelector('.selected-selling-plan-id');
    this.subscriptionRadios = this.sellingPlanForm?.querySelectorAll('.subscription-option input[type="radio"]') || document.querySelectorAll('.subscription-option input[type="radio"]');
    this.subscriptionOptions = this.sellingPlanForm?.querySelectorAll('.subscription-option') || document.querySelectorAll('.subscription-option');
    this.priceElement = this.shopifySection?.querySelector('.product-form__prices-content');
    this.addToCartForm = this.shopifySection?.querySelector('[action*="/cart/add"]');

    console.log('Subscription Options:', this.subscriptionOptions.length);
    console.log('Subscription Radios:', this.subscriptionRadios.length);
    console.log('Buy Button Input:', this.buyButtonInput);
  }

  attachEventListeners() {
    if (this.subscriptionRadios.length) {
      this.subscriptionRadios.forEach(radio => {
        radio.addEventListener('change', this.handleSubscriptionOptionChange.bind(this));
      });
    }

    // Make the entire option box clickable
    this.subscriptionOptions.forEach(option => {
      option.addEventListener('click', (e) => {
        if (e.target !== option.querySelector('input[type="radio"]')) {
          const radio = option.querySelector('input[type="radio"]');
          if (radio) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
    });
  }

  handleSubscriptionOptionChange() {
    // Update visual state of all options
    this.updateOptionsVisualState();

    // Update variant and selling plan
    this.updateVariantAndSellingPlan();

    // Update price display
    this.updatePrice();

    // Handle quantity visibility
    this.handleQuantityVisibility();
  }

  updateOptionsVisualState() {
    this.subscriptionOptions.forEach(option => {
      const radio = option.querySelector('input[type="radio"]');
      if (radio && radio.checked) {
        option.classList.add('selected');
      } else {
        option.classList.remove('selected');
      }
    });
  }

  updateVariantAndSellingPlan() {
    const selectedRadio = this.getSelectedRadio();

    if (selectedRadio && this.buyButtonInput) {
      // Update variant ID in buy button input
      const variantId = selectedRadio.dataset.variantId;
      this.buyButtonInput.value = variantId;
      this.buyButtonInput.setAttribute('data-id', variantId);

      // Update selling plan ID
      if (this.sellingPlanInput) {
        this.sellingPlanInput.value = selectedRadio.dataset.sellingPlanId || '';
      }

      // Trigger change event to update price display
      this.buyButtonInput.dispatchEvent(new Event('change', { bubbles: true }));

      // Log for debugging
      console.log('Selected:', {
        variant: selectedRadio.dataset.variantId,
        sellingPlan: selectedRadio.dataset.sellingPlanId,
        optionType: selectedRadio.dataset.optionType
      });
    }
  }

  getSelectedRadio() {
    return Array.from(this.subscriptionRadios).find(radio => radio.checked);
  }

  get selectedOptionType() {
    return this.getSelectedRadio()?.dataset.optionType;
  }

  updatePrice() {
    if (!this.priceElement) return;

    const selectedRadio = this.getSelectedRadio();
    if (!selectedRadio) return;

    const displayPrice = this.parsePrice(selectedRadio.dataset.variantPrice);
    const displayComparedAtPrice = this.parsePrice(selectedRadio.dataset.variantCompareAtPrice);

    this.updatePriceDisplay(displayPrice, displayComparedAtPrice);
  }

  parsePrice(priceString) {
    if (!priceString) return 0;
    return parseFloat(priceString.replace(/[^0-9.-]+/g, ""));
  }

  updatePriceDisplay(price, comparedAtPrice) {
    const salePriceElement = this.priceElement?.querySelector('.price--sale');
    const regularPriceElement = this.priceElement?.querySelector('.price--regular');

    if (!salePriceElement || !regularPriceElement) return;

    if (!comparedAtPrice || comparedAtPrice <= price) {
      regularPriceElement.style.display = 'none';
      salePriceElement.innerHTML = Shopify.formatMoney(price * 100);
      salePriceElement.style.display = 'block';
      this.priceElement.classList.remove('price--on-sale');
    } else {
      regularPriceElement.innerHTML = Shopify.formatMoney(comparedAtPrice * 100);
      regularPriceElement.style.display = 'block';
      salePriceElement.innerHTML = Shopify.formatMoney(price * 100);
      salePriceElement.style.display = 'block';
      this.priceElement.classList.add('price--on-sale');
    }

    const priceSaving = this.shopifySection?.querySelector('.product-form__prices-savings');
    const priceContainer = this.priceElement.parentElement;

    if (this.selectedOptionType === 'subscribe') {
      if (priceSaving) priceSaving.style.display = 'none';
      if (priceContainer) priceContainer.classList.add('subscription-price');
    } else {
      if (priceSaving) priceSaving.style.display = 'block';
      if (priceContainer) priceContainer.classList.remove('subscription-price');
    }
  }

  handleQuantityVisibility() {
    const quantity = this.shopifySection?.querySelector('.product-form__quantity');

    if (!quantity) return;

    const selectedOption = this.getSelectedRadio()?.closest('.subscription-option');

    if (
      this.selectedOptionType === 'subscribe' &&
      selectedOption?.classList.contains('hide-quantity')
    ) {
      quantity.classList.add('hidden');
      const quantityInput = quantity.querySelector(`[name="quantity"]`);
      if (quantityInput) quantityInput.value = 1;
    } else {
      quantity.classList.remove('hidden');
    }
  }

  setDefaultPurchaseOption() {
    requestAnimationFrame(() => {
      // Select first subscription option if none is selected
      const checkedRadio = this.getSelectedRadio();

      if (!checkedRadio && this.subscriptionRadios.length) {
        // Check if there's a subscribe option
        const subscribeRadio = Array.from(this.subscriptionRadios).find(
          radio => radio.dataset.optionType === 'subscribe'
        );

        if (subscribeRadio) {
          subscribeRadio.checked = true;
        } else if (this.subscriptionRadios.length) {
          this.subscriptionRadios[0].checked = true;
        }

        this.handleSubscriptionOptionChange();
      } else if (checkedRadio) {
        this.handleSubscriptionOptionChange();
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const containers = document.querySelectorAll('.selling_plan_app_container');

  if (containers.length) {
    containers.forEach(container => {
      new SellingPlansWidget(container);
    });
  } else if (document.querySelector('.selling_plan_theme_integration')) {
    // Fallback for when container doesn't have the right class but subscription options exist
    new SellingPlansWidget(document.querySelector('.selling_plan_theme_integration').parentNode);
  }
});
